"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var videoModuleConfig = [
    // Virtual since it is calculated behind the scenes of CMS
    {
        key: 'ratio',
        type: 'number',
        label_ar: 'Ratio',
        label_en: 'Ratio',
        required: false,
        is_virtual: true,
    },
    {
        // key: 'videoUrl',
        key: 'videoPath',
        type: 'video',
        max_width: 1440,
        label_ar: 'Video',
        label_en: 'Video',
        description_en: '',
        description_ar: '',
        required: true,
        sort: 1,
    },
    {
        // key: 'imageUrl',
        key: 'imagePath',
        type: 'image',
        max_width: 1440,
        label_ar: 'Poster',
        label_en: 'Poster',
        description_en: '',
        description_ar: '',
        required: true,
        sort: 1,
    },
    // Virtual as no use for this yet as not looking into analysis
    {
        key: 'widgetId',
        type: 'number',
        label_ar: 'Widget ID',
        label_en: 'Widget ID',
        required: false,
        is_virtual: true,
    },
];
exports.default = videoModuleConfig;
//# sourceMappingURL=config.js.map